import { inject } from '@angular/core';
import { RoomStatusHistoryApiService } from '@shared/services';
import { PopoverConfig, PopoverHandlerConfig } from '../generic-popover.interfaces';
import { roomStatusHistoryFormConfig } from '@shared/components/edit-create-form';
import { defaultCancelAction, defaultConfirmAction } from './default-actions';

export const roomStatusHistoryPopoverConfig = (
  onSuccess: () => void,
  onCancel: () => void,
  actionHandlers?: Record<string, (popoverConfig: PopoverHandlerConfig, formValue: any) => void | Promise<any>>
): PopoverConfig => {
  const roomStatusHistoryApiService = inject(RoomStatusHistoryApiService);

  return {
    width: '500px',
    title: 'Cập nhật tình trạng phòng',
    dismissable: true,
    formConfig: roomStatusHistoryFormConfig(),
    actions: [defaultCancelAction, defaultConfirmAction],
    actionHandlers,
    handlerConfig: {
      service: roomStatusHistoryApiService,
      method: 'createRoomStatusHistory',
      entityLabel: 'tình trạng phòng',
      commonDataTransform: (formValue: any) => ({
        roomId: formValue.roomId,
        status: formValue.status,
        fromDate: formValue.fromDate,
        reason: formValue.reason,
        note: formValue.note
      }),
      initialDataTransform: (rawData: any) => ({
        roomId: rawData.id,
        code: rawData.code,
        name: rawData.name,
        status: null,
        fromDate: new Date(new Date().setHours(0, 0, 0, 0)),
        reason: null,
        note: null
      }),
      onSuccess,
      onCancel
    } as PopoverHandlerConfig
  };
};
